<script lang="ts" setup>
import type { CategoryLevel } from "~/types/common";

// -----------------------
// props & emits
// -----------------------
defineProps<{
  root: CategoryLevel;
  level: number;
  expandedCategories: string[];
}>();

const emit = defineEmits(["refine", "toggle"]);

// -----------------------
// helper functions
// -----------------------
const toggleCategory = (event: Event, value: string) => {
  event.stopPropagation();
  event.preventDefault();

  emit("toggle", value);
};

const toggleRefined = (category: CategoryLevel) => {
  emit("refine", category);
};

const hasSubcategories = (category: CategoryLevel) => {
  return Object.keys(category.children).length > 0;
};
</script>

<template>
  <ul
    class="!m-0 !p-0 !list-none cursor-pointer select-none"
    :class="{ '!mt-2.5': level > 1 }"
  >
    <li
      v-for="category in root.children"
      :key="category.path"
      class="!flex items-center leading-5 mb-2.5 last:mb-0"
      :class="{
        'ml-0': level === 1,
        'ml-2': level === 2,
        'ml-4': level === 3,
        'flex-wrap': expandedCategories.includes(category.path),
      }"
    >
      <div
        v-if="hasSubcategories(category)"
        class="text-center text-2xl leading-6 text-[#b27c56] mr-1.5 flex-[0_0_1rem]"
        @click="toggleCategory($event, category.path)"
      >
        {{ expandedCategories.includes(category.path) ? "-" : "+" }}
      </div>
      <div v-else class="flex-[0_0_1rem] mr-1.5"></div>

      <span
        class="grow-0 shrink"
        :class="{
          'font-bold': category.isRefined,
        }"
        @click="toggleRefined(category)"
        >{{ category.label }}</span
      >

      <div
        v-if="expandedCategories.includes(category.path)"
        class="w-full"
      ></div>

      <ProductListHierarchicalFilterLevel
        v-if="expandedCategories.includes(category.path)"
        :root="category"
        :level="level + 1"
        :expanded-categories="expandedCategories"
        @refine="$emit('refine', $event)"
        @toggle="$emit('toggle', $event)"
      />
    </li>
  </ul>
</template>
